import { ScheduledReportsPage } from "./ScheduledReportsPage";

export default ScheduledReportsPage;
